module.exports = __webpack_public_path__ + "h5/img/0.01@2x.69f3c55f.png";